export default function to(promise: Promise<any>) {
  return promise.then((data: any) => [null, data]).catch((err: any) => [err]);
}
